import { Typography } from 'antd';

interface Props {
  /** 主標題 */
  title: string;
  /** 副標／統計說明（如「共 13 篇文章」） */
  subtitle?: React.ReactNode;
  /** 右側主要動作（按鈕等） */
  extra?: React.ReactNode;
}

/**
 * 統一的頁面標題列：左側標題 + 副標，右側主要動作。
 * 全後台一致使用，建立穩定的視覺節奏與層次。
 */
export default function PageHeader({ title, subtitle, extra }: Props) {
  return (
    <div className="mb-4 flex flex-nowrap items-start justify-between gap-3 border-b border-black/[0.06] pb-3 md:mb-6 md:pb-4">
      <div className="min-w-0">
        <Typography.Title level={3} className="!mb-0.5 !text-[20px] !font-semibold md:!text-[22px] !leading-tight">
          {title}
        </Typography.Title>
        {subtitle != null && (
          <p className="m-0 line-clamp-1 text-[12px] leading-tight text-gray-400 md:text-[13px]">{subtitle}</p>
        )}
      </div>
      {extra && <div className="flex shrink-0 items-center gap-2">{extra}</div>}
    </div>
  );
}
